webpackJsonp([52470039999506],{

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/icon-sri.78b07cf6.svg";

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img-principal-sri.7d137e82.jpg";

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  background: #202122;\n\n  & p {\n    padding: 0;\n    padding-top: 20px !important;\n  }\n\n  & .title {\n    padding: 0;\n  }\n  & .btn-impuestos {\n    font-weight: 500;\n    font-style: normal;\n    letter-spacing: 1px;\n    padding: 13px 20px;\n    color: #202122;\n    font-size: 20px;\n    margin-top: 0;\n    background: #999a9f;\n    background: linear-gradient(\n      135deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#999a9f', endColorstr='#cbcacb',GradientType=1 );\n    display: inline-block;\n  }\n"], ["\n  background: #202122;\n\n  & p {\n    padding: 0;\n    padding-top: 20px !important;\n  }\n\n  & .title {\n    padding: 0;\n  }\n  & .btn-impuestos {\n    font-weight: 500;\n    font-style: normal;\n    letter-spacing: 1px;\n    padding: 13px 20px;\n    color: #202122;\n    font-size: 20px;\n    margin-top: 0;\n    background: #999a9f;\n    background: linear-gradient(\n      135deg,\n      #999a9f 0%,\n      #999a9f 21%,\n      #b0b0b3 21%,\n      #b0b0b3 48%,\n      #cbcacb 48%,\n      #cbcacb 100%\n    );\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#999a9f', endColorstr='#cbcacb',GradientType=1 );\n    display: inline-block;\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 70%;\n  margin: 10px auto;\n\n  td,\n  th {\n  }\n  ", ";\n"], ["\n  width: 70%;\n  margin: 10px auto;\n\n  td,\n  th {\n  }\n  ", ";\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    font-size: 12px;\n    th {\n      padding-right: 20px;\n    }\n  "], ["\n    width: 100%;\n    font-size: 12px;\n    th {\n      padding-right: 20px;\n    }\n  "]),
	    _templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 70%;\n  margin: 20px auto;\n\n  ", ";\n"], ["\n  width: 70%;\n  margin: 20px auto;\n\n  ", ";\n"]),
	    _templateObject5 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n\n    & .btn-down {\n      margin-top: 10px;\n    }\n  "], ["\n    width: 100%;\n\n    & .btn-down {\n      margin-top: 10px;\n    }\n  "]);
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _template = __webpack_require__(79);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _styledComponents = __webpack_require__(31);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _theme = __webpack_require__(55);
	
	var _media = __webpack_require__(35);
	
	var _media2 = _interopRequireDefault(_media);
	
	var _imgPrincipalSri = __webpack_require__(566);
	
	var _imgPrincipalSri2 = _interopRequireDefault(_imgPrincipalSri);
	
	var _iconSri = __webpack_require__(563);
	
	var _iconSri2 = _interopRequireDefault(_iconSri);
	
	var _ModalCondition = __webpack_require__(78);
	
	var _ModalCondition2 = _interopRequireDefault(_ModalCondition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.div(_templateObject);
	
	var TableInfo = _styledComponents2.default.table(_templateObject2, _media2.default.sm(_templateObject3));
	
	var Buttons = _styledComponents2.default.div(_templateObject4, _media2.default.sm(_templateObject5));
	
	var title = "Paga tus impuestos en línea.";
	
	var ImpuestosSRI = function ImpuestosSRI(props) {
	  var _useState = (0, _react.useState)(false),
	      isOpen = _useState[0],
	      setIsOpen = _useState[1];
	
	  function toggleModal() {
	    setIsOpen(!isOpen);
	  }
	  return _react2.default.createElement(
	    _template2.default,
	    { banner: _imgPrincipalSri2.default, title: title, icon: _iconSri2.default, active: "sri" },
	    function (_ref) {
	      var handleModalShow = _ref.handleModalShow;
	      return _react2.default.createElement(
	        Content,
	        { className: "row" },
	        _react2.default.createElement(
	          "div",
	          { "class": "col-md-12" },
	          "\xA0"
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-lg-12" },
	          _react2.default.createElement(
	            "div",
	            { className: "text-center" },
	            _react2.default.createElement(
	              "a",
	              {
	                id: "CORPIMP_SRI_CONOZCA",
	                className: "btn-impuestos",
	                onClick: toggleModal
	              },
	              "Conozca m\xE1s sobre la clave temporal"
	            ),
	            _react2.default.createElement(_ModalCondition2.default, {
	              onAfterOpen: false,
	              isOpen: isOpen,
	              onRequestClose: toggleModal,
	              ariaHideApp: false,
	              contentLabel: "ModalMunicipio"
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _theme.Container,
	          { className: "title" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12" },
	            _react2.default.createElement(
	              "p",
	              null,
	              "Pague sus impuestos en el SRI"
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _theme.Container,
	          { className: "content" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-12" },
	            _react2.default.createElement(
	              TableInfo,
	              null,
	              _react2.default.createElement(
	                "thead",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "th",
	                    null,
	                    "Impuestos y obligaciones que puede cancelar."
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "tbody",
	                null,
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Impuesto a la renta"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd text-left" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Retenci\xF3n a la fuente"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Multas"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "IVA"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "ICE"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Impuesto a salida de divisas"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Impuesto a los activos en el exterior"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  { className: "odd" },
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Inter\xE9s por mora tributarios"
	                  )
	                ),
	                _react2.default.createElement(
	                  "tr",
	                  null,
	                  _react2.default.createElement(
	                    "td",
	                    null,
	                    "Anticipos"
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              Buttons,
	              null,
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "text-center" },
	                  _react2.default.createElement(
	                    "a",
	                    {
	                      href: "https://www.optar.com.ec/Optar.BPagos.Sri/PagoSriAS.aspx",
	                      target: "_blank",
	                      className: "btn-impuestos",
	                      id: "CORPIMP_SRI_PAY"
	                    },
	                    "Pague Aqu\xED"
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  );
	};
	
	exports.default = ImpuestosSRI;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-impuestos-sri-js-31d8856a0eab1a5b80c0.js